import { Component, Input } from "@angular/core";

@Component({
  selector: "app-icon-close",
  imports: [],
  templateUrl: "./icon-close.component.html",
  styleUrl: "./icon-close.component.scss",
})
export class IconCloseComponent {
  @Input() color: string = "#000";
}
